import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconLinkOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" fillRule="nonzero" d="m15.13 14.087 6.783-6.783-5.217-5.217L9.913 8.87 8.87 7.826l6.782-6.783a1.476 1.476 0 0 1 2.087 0l5.218 5.218c.576.576.576 1.51 0 2.087l-6.783 6.782zm-1.043 1.043 1.043 1.044-6.782 6.783a1.476 1.476 0 0 1-2.087 0l-5.218-5.218a1.476 1.476 0 0 1 0-2.087L7.826 8.87 8.87 9.913l-6.783 6.783 5.217 5.217zm-7.826 1.566L16.696 6.26l1.043 1.043L7.304 17.74z" /></svg>
);
